import { Form, Input } from 'antd';
import type { Rule } from 'antd/lib/form';
import { isNil } from 'lodash';

type IProps = {
    required?: boolean;
    label: string;
    placeholder?: string;
    propertyName: string;
    max?: number;
    min?: number;
    initialValue?: number;
};

export default function NumberFilter({
    required,
    label,
    placeholder,
    propertyName,
    max,
    min,
    initialValue,
}: IProps) {
    const rules: Rule[] = required
        ? [
            {
                required: true,
                message: 'É obrigatório preencher o campo',
            },
            () => ({
                validator(_, value) {
                    if (value && !isNil(min) && value < min) {
                        return Promise.reject(new Error(`Valor deve ser maior que ${min}`));
                    }

                    if (value && !isNil(max) && value > max) {
                        return Promise.reject(new Error(`Valor deve ser menor que ${max}`));
                    }

                    return Promise.resolve();
                },
            }),
        ]
        : [];

    return (
        <Form.Item
            label={label}
            name={propertyName}
            rules={rules}
            initialValue={initialValue}
        >
            <Input
                placeholder={placeholder}
                min={min}
                max={max}
            />
        </Form.Item>
    );
}
